<div 
  class="box-section command-palette-container" 
  [style.--box-border-color]="color_primario || ''"
>
  <div class="search-header">
    <mat-icon class="search-icon" [style.color]="color_primario || ''">search</mat-icon>
    <input 
      type="text" 
      placeholder="Buscar módulo o menú..." 
      [(ngModel)]="searchQuery" 
      (input)="filterModules()"
      class="search-input"
      autofocus
    />
    <span class="esc-badge">ESC</span>
  </div>

  <div class="results-container" *ngIf="groupedModules.length > 0; else noResults">
    <div *ngFor="let group of groupedModules" class="group-container">
      <!-- Encabezado de la categoría -->
      <div class="group-header">
        <mat-icon class="group-header-icon" [svgIcon]="group.icono || 'heroicons_outline:squares-2x2'"></mat-icon>
        <span class="group-header-title">{{ group.category }}</span>
      </div>

      <!-- Módulos de la categoría -->
      <div 
        *ngFor="let mod of group.items" 
        [class.active]="mod.globalIndex === selectedIndex"
        [style.background-color]="mod.globalIndex === selectedIndex && color_primario ? color_primario + '1A' : ''"
        [style.color]="mod.globalIndex === selectedIndex && color_primario ? color_primario : ''"
        (click)="navigate(mod)"
        (mouseenter)="selectedIndex = mod.globalIndex"
        class="result-item"
      >
        <span class="item-label">{{ mod.label }}</span>
        <span 
          class="enter-badge" 
          *ngIf="mod.globalIndex === selectedIndex"
          [style.background-color]="color_primario ? color_primario + '1A' : ''"
          [style.color]="color_primario || ''"
        >↵ Ir</span>
      </div>
    </div>
  </div>

  <ng-template #noResults>
    <div class="no-results">
      <mat-icon>search_off</mat-icon>
      <p>No se encontraron módulos para tu búsqueda.</p>
    </div>
  </ng-template>
</div>
